import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import { dmClient } from '../services/dmClient';

export default function ActivatePage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState('working'); // working | ok | error
  const [message, setMessage] = useState('Verifying your email…');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setState('error');
      setMessage('No activation token was provided.');
      return;
    }
    dmClient
      .get('/auth/activate', { params: { token } })
      .then((r) => {
        setState('ok');
        setMessage(r.data?.message || 'Your email is verified. You can now sign in.');
      })
      .catch((e) => {
        setState('error');
        setMessage(e?.response?.data?.error || 'This activation link is invalid or has expired.');
      });
  }, [token]);

  return (
    <AuthLayout title="Email verification" footer={<Link to="/login">Go to sign in</Link>}>
      <div className={state === 'error' ? 'auth-error' : 'auth-success'}>
        <p>{message}</p>
      </div>
    </AuthLayout>
  );
}
